import React from 'react';
import { Modal, Upload, message, Icon } from 'antd';

const Dragger = Upload.Dragger;

const onChange = (info, onOk) => {
  const status = info.file.status;

  if (status !== 'uploading') {
    console.log(info.file, info.fileList);
  }

  if (status === 'done') {
    message.success(`${info.file.name} file uploaded successfully.`);
    onOk();
  } else if (status === 'error') {
    message.error(`${info.file.name} file upload failed.`);
  }
};

export default props => {
  const { onOk, onCancel, visible, token } = props;

  return (
    <Modal title="Upload Inventory" visible={visible} onCancel={onCancel} onOk={onCancel}>
      <Dragger
        name="file"
        multiple={false}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        action={`${process.env.REACT_APP_API_HOST}/cms/inventory_uploads`}
        headers={{ Authorization: token }}
        onChange={info => onChange(info, onOk)}
      >
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
      </Dragger>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/Inventory/UploadModal.js